import styled from '@emotion/styled';
import { Layout } from 'antd';

import { theme } from '../../../../theme/theme';
import { getThemeValueByName } from '../../../../utilities/styling/UseCssVarByName';

export const MeasurePageMainContainer = styled(Layout.Content)`
	background-color: ${theme.colors.white};
	display: flex;
	flex-direction: column;
	padding-block: 25px 0;
	padding-inline: 33px;
	overflow-y: auto;
	scroll-behavior: smooth;
	position: relative;
	block-size: 100%;
	row-gap: 12px;
`;

export const MeasureTableContainer = styled.div`
	inline-size: 100%;
	border-radius: 10px;
	border: 1px solid ${getThemeValueByName('colorBorder')};
`;
